import styled from 'styled-components'

import { Drawer } from '@/ui/atoms/drawer'
import { Flex } from '@/ui/atoms/flex'

export const FilterDrawer = styled(Drawer)`
  padding: 0 !important;
  overflow: unset !important;
  border-radius: 0;
`

export const FilterDrawerMainWrapper = styled(Flex)`
  width: 560px;
  overflow-y: auto;
  flex: 1;
  max-width: 100vw; // Need this for mobile screens so it doesn't extend past the viewport
`

export const FilterDrawerHeader = styled.header(
  ({ theme }) => `
    padding: ${theme.spacing.default};
    border-bottom: 0.1rem solid ${theme.colors.grey.light4};
    background: ${theme.colors.white};
  `
)

export const FilterDrawerAccordionContainer = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`

export const FilterDrawerFooter = styled.footer(
  ({ theme }) => `
    display: flex; 
    justify-content: space-between;
    border-top: 0.1rem solid ${theme.colors.grey.light4};
    background-color: ${theme.colors.white};
    padding: ${theme.spacing.default} ${theme.spacing.large}; 
    
  `
)
